// Lib
import React from 'react';
import styled from 'styled-components';
import { useSelector } from 'react-redux';
import { Flex, Heading, Button } from 'rebass';

// Theme
import colors from 'theme/colors';

// Components
import Icon from '../Icon';
import ModalContent from './ModalContent';

const Content = styled(ModalContent)`
  max-width: 420px;
  max-height: 90%;
  width: 100%;
  flex-direction: column;
`;

const FormButton = styled(Button)<any>`
  width: 100%;
  border-radius: 0;
  font-size: 20px;
  font-weight: 600;
  padding-top: 20px;
  padding-bottom: 20px;
  cursor: pointer;
  outline: none;
  opacity: ${props => (props.submitting ? '0.5' : '1')};
  cursor: ${props => (props.submitting ? 'wait' : 'pointer')};
`;

const CandidateItems = styled(Flex)`
  overflow-y: auto;
`;

const CandidateItem = styled(Flex)`
  align-items: center;
  border-bottom: 1px solid ${colors.darkGray};
  padding: 15px 0;
  font-size: 18px;
  justify-content: space-between;
`;

const ModalIcon = styled(Icon)<any>`
  cursor: pointer;
  margin-right: ${props => (props.withMargin ? '20px' : '0')};

  & svg {
    width: 30px;
    height: 30px;
  }
`;

interface ArchivedCandidatesProps {
  closeModalHandler: VoidFunction;
}

const ArchivedCandidates: React.FC<ArchivedCandidatesProps> = (props): JSX.Element => {
  const { closeModalHandler } = props;
  const {
    modal: {
      data: { onRestore, onInfo },
    },
    candidates,
  } = useSelector<any, any>(state => ({
    modal: state.modal,
    candidates: state.archivedCandidates,
  }));

  return (
    <Content>
      <Flex width="100%" px={3} pt={4}>
        <Heading fontSize="30px" fontWeight={6} mb={2}>
          Archived Candidates
        </Heading>
      </Flex>
      <CandidateItems width="100%" px={3} flexDirection="column">
        {candidates.map((candidate: any) => (
          <CandidateItem key={candidate.id}>
            {candidate.firstName} {candidate.lastName}
            <div>
              <ModalIcon type="restore" onClick={onRestore(candidate)} withMargin />
              <ModalIcon type="info" onClick={onInfo(candidate.id)} />
            </div>
          </CandidateItem>
        ))}
      </CandidateItems>
      <Flex width="100%" flexDirection="column" mt={5}>
        <FormButton type="button" bg="lightGreen" onClick={closeModalHandler}>
          <Flex justifyContent="center" alignItems="center">
            <ModalIcon type="check" withMargin />
            Done
          </Flex>
        </FormButton>
      </Flex>
    </Content>
  );
};

export default ArchivedCandidates;
